module.exports = {"id":"ffb44070-b041-4f46-98c1-53f1d1dfd9c5","section":"General","name":"general","items":[{"name":"general_industry","text":"In what industries does your company operate?","type":"checkbox-list","props":{"items":"sp_industry_types","label":"Industries","required":true,"multiple":true},"subItems":[{"name":"general_industry-other","text":"Other applicable industries:","type":"text-field","props":{"label":"Other Industry","required":true},"dependencies":{"items":[{"name":"general_industry","value":"other","operator":"contains"}]}}]}]}


//////////////////
// WEBPACK FOOTER
// ./src/components/succession-elite/valuation-data/general.json
// module id = EV5w
// module chunks = 0